<template>
  <validation-provider name="baseInputEditValidationProvider" ref="validationInput" :rules="rules" v-slot="{errors, valid}">
    <div class="input-box" :class="errors.length > 0 ? 'error' : ''">
        <div class="form-group form-control">
          <upload-image name="imageValidation" v-model="displayModel"></upload-image>
          <small class="error-text">{{errors[0]}}</small>
        </div>
    </div>
  </validation-provider>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import validationMethodsMixin from "../../mixin/validationMethodsMixin";
import UploadImage from "../common/UploadImage";


export default {
  name: "BaseImageEditInput",
  mixins : [validationMethodsMixin],
  components : {ValidationProvider, UploadImage},
  data :() => {
    return {
      valid : null,
      displayModel : null
    };
  },
  props : {
    rules : String,
    inputModel : null
  },
  model: {
    prop: 'inputModel',
    event: 'change'
  },
  mounted() {
    extend("required", {...required,
      message : required.message =  'Required'});

    this.displayModel = this.inputModel;
  }
}
</script>

<style scoped>

</style>